
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class CouponContent extends Vue {
  @Prop({ default: () => {} })
  couponData: any;
  discountRateFormat(value) {
    return (100 - value * 100).toFixed(2);
  }
}
